import React from "react";

import { Button, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { getUrlLangPrefix } from "@/utils/Local";

import FaCheckCircle from "../../assets/icons/faCheckCircle.svg";
import FaHome from "../../assets/icons/faHome.svg";
import i18n from "../../i18n";

export default function ReserveSuccess() {
  const { t } = i18n;

  return (
    <Container className="">
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "70vh" }}
      >
        <div className="d-flex flex-column justify-content-between align-items-center gap-3 w-50 text-center">
          <img alt={t(`reserve-success`)} src={FaCheckCircle} />
          <h1>{t(`You're in!`)}</h1>

          <p>
            {t(
              `We've received your payment and reserved your spot. A confirmation email is on its way to your inbox.`,
            )}
          </p>

          <NavLink className="mt-2" to={`${getUrlLangPrefix()}/`}>
            <Button variant="outline-primary d-flex justify-content-center gap-2 ps-4 pe-4 pt-2 pb-2">
              <img alt={t(`home`)} src={FaHome} />
              <span>{t("go_to_homepage")}</span>
            </Button>
          </NavLink>
        </div>
      </div>
    </Container>
  );
}
